import { createReducer } from '@reduxjs/toolkit'
import {
  setCurrentSubscriptionPlan,
  setFilePaymentStatus,
  setIntentClientSecret,
  setIsLoading,
  setIsPaymentProcessing,
  setPricingProduct,
  setSelectedOneTimePaymentProductName,
  setShowSubscriptionModalDialog,
  setSubscriptionInvoices,
  setSubscriptions,
  setSubscriptionsLoadingInProgress,
} from '../actions/payment'
import { Invoice, Subscription } from '../models/Subscription'

const initialState: PaymentState = {
  subscriptions: [],
  isSubscriptionsLoadingInProgress: false,
  isLoading: false,
  isPaymentProcessing: false,
  filePaidServices: [''],
  showSubscriptionModalDialog: false,
  subscriptionInvoices: [],
}

interface PaymentState {
  subscriptions: []
  isSubscriptionsLoadingInProgress: boolean
  setupIntentClientSecret?: string
  isLoading: boolean
  pricingProduct?: any
  isPaymentProcessing: boolean
  selectedOneTimePaymentProductName?: string
  filePaidServices: [any]
  currentSubscriptionPlan?: Subscription
  showSubscriptionModalDialog: boolean
  subscriptionInvoices: Invoice[]
}

const paymentReducer = createReducer(initialState, (builder) => {
  builder.addCase(setSubscriptions, (state, action) => {
    state.subscriptions = action.payload
  })
  builder.addCase(setSubscriptionsLoadingInProgress, (state, action) => {
    state.isSubscriptionsLoadingInProgress = action.payload
  })
  builder.addCase(setIntentClientSecret, (state, action) => {
    state.setupIntentClientSecret = action.payload
  })
  builder.addCase(setIsLoading, (state, action) => {
    state.isLoading = action.payload
  })
  builder.addCase(setPricingProduct, (state, action) => {
    state.pricingProduct = action.payload
  })
  builder.addCase(setIsPaymentProcessing, (state, action) => {
    state.isPaymentProcessing = action.payload
  })
  builder.addCase(setSelectedOneTimePaymentProductName, (state, action) => {
    state.selectedOneTimePaymentProductName = action.payload
  })
  builder.addCase(setFilePaymentStatus, (state, action) => {
    state.filePaidServices = action.payload
  })
  builder.addCase(setCurrentSubscriptionPlan, (state, action) => {
    state.currentSubscriptionPlan = action.payload
  })
  builder.addCase(setShowSubscriptionModalDialog, (state, action) => {
    state.showSubscriptionModalDialog = action.payload
  })
  builder.addCase(setSubscriptionInvoices, (state, action) => {
    state.subscriptionInvoices = action.payload
  })
})

export default paymentReducer
